export default __webpack_public_path__ + "static/media/template_logo.39a09d1e.svg";